import React from "react";
import style from "./ErrorProcessingDialog.module.scss";
import { withTranslation } from "react-i18next";
import FordLogo from "../common/FordLogo";
import Button from "@mui/material/Button";

function PageError(props) {
  function goBack() {
    window.history.back();
    props.close();
  }

  return (
    <div className="pageWrapper">
      <div className={style.center}>
        <FordLogo className={style.brandLogo} />
        <div className={style.deniedTitle}>{props.code}</div>
        <div className={style.deniedInfo}>{props.body}</div>
        <Button className={style.confirm} onClick={() => goBack()}>
          {props.t("Error.goBack")}
        </Button>
      </div>
    </div>
  );
}

export default withTranslation("emp")(PageError);
